export const content = {
  company: {
    name: 'E8 Solutions',
    email: 'info@e8solutions.io',
    address: {
      state: 'Colorado'
    }
  },
  hero: {
    title: 'Elevate Your Business Performance',
    subtitle: 'Comprehensive suite of SaaS tools and solutions designed to boost your business efficiency, productivity, and growth.'
  },
  products: {
    saas: [
      {
        id: 'city-tagger',
        name: 'Zillow - Tag Lead by Request City',
        description: 'Automatically tag Zillow leads with the city where their showing request originated for better lead organization and tracking',
        features: [
          'Automatic city detection from showing requests',
          'Real-time lead tagging',
          'Follow Up Boss integration',
          'Standardized tag format'
        ],
        image: '/zillow-lead-city-tagger-logo.png',
        logo: '/zillow-lead-city-tagger-logo.png'
      },
      {
        id: 'referral-link',
        name: 'ReferralLink',
        description: 'Complete referral management system for real estate brokers and agents to track incoming and outgoing referrals',
        features: [
          'Track incoming & outgoing referrals',
          'CRM synchronization',
          'Automated referral company updates',
          'Referral status tracking'
        ],
        image: '/referrallink-bg.jpg'
      },
      {
        id: 'lead-data',
        name: 'Lead Data',
        description: 'AI-powered tool to automatically complete and enrich your lead data',
        features: [
          'Automatic data completion',
          'Real-time validation',
          'Multi-source enrichment',
          'CRM integration'
        ],
        image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=800'
      },
      {
        id: 'zillow-assistant',
        name: 'Zillow Premier Agent Call Assistant',
        description: 'AI-powered conversation assistant for Zillow lead calls',
        features: [
          'Real-time AI powered conversation suggestions',
          'Smart ALM suggestions',
          'Follows Zillow Best Practices'
        ],
        image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=800'
      },
      {
        id: 'trading-assistant',
        name: 'AI Powered Futures Trading Assistant',
        description: 'Intelligent analysis and decision support for futures trading',
        features: [
          'Market trend analysis',
          'Risk assessment',
          'Real-time alerts',
          'Performance tracking'
        ],
        image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=800'
      }
    ],
    services: [
      {
        id: 'seo-optimization',
        name: 'SEO Optimization Suite',
        description: 'Comprehensive SEO tools to boost your online visibility',
        features: [
          'Keyword research and analysis',
          'Content optimization',
          'Technical SEO audits',
          'Competitor analysis'
        ],
        image: '/seo-optimization.png',
        category: 'Marketing'
      },
      {
        id: 'brand-design',
        name: 'Brand Design & Graphics',
        description: 'Professional design services for your brand identity',
        features: [
          'Logo design',
          'Brand guidelines',
          'Marketing materials',
          'Social media graphics'
        ],
        image: 'https://images.unsplash.com/photo-1561070791-2526d30994b5?auto=format&fit=crop&q=80&w=800',
        category: 'Marketing'
      },
      {
        id: 'social-media',
        name: 'Social Media Management',
        description: 'Complete social media management and growth solution',
        features: [
          'Content strategy',
          'Post scheduling',
          'Engagement monitoring',
          'Analytics reporting'
        ],
        image: 'https://images.unsplash.com/photo-1562577309-4932fdd64cd1?auto=format&fit=crop&q=80&w=800',
        category: 'Marketing'
      },
      {
        id: 'virtual-assistant',
        name: 'Virtual Assistant Services',
        description: 'Professional virtual assistant services to support your business',
        features: [
          'Administrative support',
          'Email and calendar management',
          'Customer service',
          'Project coordination'
        ],
        image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=800',
        category: 'Support'
      }
    ]
  }
};